import { useState } from 'react';
import { Button } from '@/components/ui/therapist/Button';
import { logError } from '@/utils/logHandling';
import { Modal } from '@/components/ui/therapist/Modal';
import { Text } from '@/components/Text';
import { useAuth } from '@/hooks/useAuth';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';

export const useDeleteLocallyStoredData = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { logoutAndClearAll } = useAuth();
  const { showNotification } = useNotification();

  const deleteLocallyStoredData = async () => {
    try {
      await logoutAndClearAll();

      showNotification({
        title: 'App-Speicher wurde zurückgesetzt.',
        type: 'success',
      });
    } catch (e) {
      logError('Failed deleting data', e);
      showNotification({
        title: 'App-Speicher konnte nicht zurückgesetzt werden.',
        type: 'error',
      });
    } finally {
      setShowModal(false);
    }
  };

  return {
    openDeleteLocallyStoredDataModal: () => setShowModal(true),
    deleteLocallyStoredDataModal: (
      <Modal
        isVisible={showModal}
        title="App-Speicher zurücksetzen?"
        onClose={() => setShowModal(false)}
        confirmActionButton={
          <Button
            label="Zurücksetzen"
            look="danger"
            onPress={deleteLocallyStoredData}
          />
        }
        cancelActionButton={
          <Button
            label="Abbrechen"
            look="secondary"
            onPress={() => setShowModal(false)}
          />
        }
      >
        <Text>
          Beim Zurücksetzen werden alle sensiblen Daten auf diesem Gerät
          gelöscht und Sie werden automatisch ausgeloggt. Möchten Sie
          fortfahren?
        </Text>
      </Modal>
    ),
  };
};
